import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { IApplication } from 'src/app/models/application-form/application-form.model';
import { AbstractDealAnalyticsService } from 'src/app/services/deal-analytics/abstract-deal-analytics.service';

@Component({
    selector: 'appform-question-set',
    templateUrl: './question-set.component.html',
    styleUrls: ['./question-set.component.css'],
    standalone: false
})
export class QuestionSetComponent implements OnChanges, OnDestroy {
  @Output() businessTypeLoad = new EventEmitter<boolean>();
  @Output() questionSetUpdate = new EventEmitter<any>();
  @Input() isAppFormReady$ = new ReplaySubject<boolean>();
  @Input() activeMenuOrder: number;
  @Input() readOnly: boolean;
  @Input() formData: IApplication;
  @Input() isAppSyncedWithBP$: BehaviorSubject<boolean>;

  @Input() isContactInfoReady: boolean;
  @Input() isProductInfoReady: boolean;
  @Input() isBusinessTypeReady: boolean;
  @Input() isGeneralInfoReady: boolean;

  constructor(
    private dealAnalyticsService: AbstractDealAnalyticsService
  ) {}

  public get hideStepper(): boolean {
    if (this.isAppSyncedWithBP$.getValue()) {
      return this.isContactInfoReady && this.isProductInfoReady && this.isBusinessTypeReady && this.isGeneralInfoReady;
    } else {
      return true;
    }
  }
  @ViewChild('stepper') stepper: MatStepper;

  public updateQuestionSet(event: any) {
    this.questionSetUpdate.emit(event);
  }

  public onWebComponentLoad(event: any) {
    this.businessTypeLoad.emit(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.stepper) {
      if (changes?.activeMenuOrder) {
        switch (changes?.activeMenuOrder.currentValue) {
          case 1:
            this.stepper.steps.find((step) => step.label === 'Contact Info').select();
            break;
          case 2:
            this.stepper.steps.find((step) => step.label === 'Coverage Type').select();
            break;
          case 3:
            this.stepper.steps.find((step) => step.label === 'Business Types').select();
            break;
          default:
            break;
        }
      }
    }
    this.dealAnalyticsService.postDealPageEvent(null, null);
  }
  ngOnDestroy(): void {
    this.isAppFormReady$.next(false);
  }
}
